<template>
  <div>
    <b-row v-if="!EntityForm">
      <b-col :cols='12'>
        <h3>Nueva visita</h3>
      </b-col>
      <b-col :cols='12'>
        <b-form>
          <b-alert :show='alertSaved == 1' variant='success' dismissible>Guardado satisfactoriamente</b-alert>
          <b-alert :show='alertSaved == 2' variant='danger' dismissible>Error (GC-GUARDADO)</b-alert>
          <b-row>
            <b-col :cols='4'>
              <b-form-group
                id="exampleInputGroup1"
                label="Entidad:"
                label-for="exampleInput1"
                description="">
                <multiselect
                  placeholder="Seleccionar"
                  deselect-label="Click o enter para deseleccionar"
                  select-label="Click o enter para seleccionar"
                  v-model="inputs.entity.value"
                  :options="inputs.entity.options"
                  :multiple="false"
                  :close-on-select="true"
                  :clear-on-select="true"
                  :preserve-search="true"
                  label="name"
                  track-by="value"
                  :preselect-first="true"
                  v-validate="'required'"
                  name="Entidad">
                </multiselect>
                <span class="error">{{ errors.first('Entidad') }}</span>
              </b-form-group>
            </b-col>
            <b-col :cols='3'>

              <b-form-group id="inputGroup" class="mt-24">
                <b-button
                  @click='showPublicOffer()'
                  size='lg'
                  :disabled="disabledOffer"
                  variant='default'>
                  <i class='p-0 fa fa-eye'></i>&nbsp; Oferta pública
                </b-button>
                <b-button @click="sendEmail"><i class='fa fa-plus'></i>&nbsp; Nueva entidad</b-button>
              </b-form-group>
            </b-col>
            <b-col :cols='4'>
              <b-form-group id="exampleInputGroup1"
                            label="Distribuidora:"
                            label-for="exampleInput1"
                            description="">
                <b-form-select v-model="inputs.distributor.value" :options="inputs.distributor.options" class="mb-3"
                               size="sm" name="Distribuidora"/>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col :cols='4'>
              <b-form-group id="exampleInputGroup1"
                            label="Visitador:"
                            label-for="exampleInput1"
                            description="">

                <b-form-input id="exampleInput1"
                              :disabled='true'
                              type="text"
                              v-model="inputs.visitador"
                              required
                              placeholder="" name="Visitador">
                </b-form-input>
              </b-form-group>
            </b-col>

            <b-col>
              <b-form-group id="exampleInputGroup1"
                            label="Estado:"
                            label-for="exampleInput1"
                            description="">
                <b-form-select v-model="inputs.status.value" :options="inputs.status.options" class="mb-3" size="sm"
                               name="Estado" v-validate="'required'"/>
                <span class="error">{{ errors.first('Estado') }}</span>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col :cols='4'>
              <b-form-group id="exampleInputGroup1"
                            label="Fecha visita realizada:"
                            label-for="exampleInput1"
                            description="">
                <b-input-group>
                  <datetime
                    name="Fecha y hora realizada"
                    v-model="inputs.visitedDate"
                    input-class="form-control"
                    :phrases="{ok: 'Ok', cancel: 'Cancelar'}"
                    type="datetime"
                    :auto="true"
                    :minute-step="15"
                    value-zone="local"
                    :max-datetime="currentDate"
                    :format="{
                                      year: 'numeric',
                                      month: '2-digit',
                                      day: '2-digit',
                                      hour: 'numeric',
                                      minute: '2-digit',
                                      hour12: false
                                      }"
                    zone="local"
                    v-validate="isDoneRequired">
                  </datetime>
                  <b-input-group-text slot="append" @click="inputs.visitedDate = ''">
                    <strong class="text-danger"><i class="fa fa-times"></i></strong>
                  </b-input-group-text>
                </b-input-group>
                <span class="error">{{ errors.first('Fecha y hora realizada') }}</span>
              </b-form-group>
            </b-col>

            <b-col :cols='4'>
              <b-form-group id="exampleInputGroup1"
                            label="Fecha visita planificada:"
                            label-for="exampleInput1"
                            description="">
                <b-input-group>
                  <datetime
                    name="Fecha y hora planificada"
                    v-model="inputs.scheduledDate"
                    input-class="form-control"
                    :phrases="{ok: 'Ok', cancel: 'Cancelar'}"
                    type="datetime"
                    :auto="true"
                    :minute-step="15"
                    value-zone="local"
                    :format="{
                                    year: 'numeric',
                                    month: '2-digit',
                                    day: '2-digit',
                                    hour: 'numeric',
                                    minute: '2-digit',
                                    hour12: false
                                    }"
                    zone="local"
                    v-validate="isPlanifiedRequired">
                  </datetime>
                  <b-input-group-text slot="append" @click="inputs.scheduledDate = ''">
                    <strong class="text-danger"><i class="fa fa-times"></i></strong>
                  </b-input-group-text>
                </b-input-group>
                <span class="error">{{ errors.first('Fecha y hora planificada') }}</span>
              </b-form-group>
            </b-col>
          </b-row>

          <b-row>
            <b-col :cols='4'>
              <b-form-group id="exampleInputGroup1"
                            label="Tipo actividad:"
                            label-for="exampleInput1"
                            description="">
                <b-form-select v-validate="'required'" v-model="inputs.activityType.value"
                               :options="inputs.activityType.options" class="mb-3" size="sm" name="Tipo actividad"/>
                <span class="error">{{ errors.first('Tipo actividad') }}</span>
              </b-form-group>
            </b-col>

            <b-col :cols='2'>
              <b-form-group id="exampleInputGroup1"
                            label="Resultado:"
                            label-for="exampleInput1"
                            description="">
                <b-form-select v-validate="(inputs.status.value === 3) ? 'required':''" v-model="inputs.result.value"
                               :options="inputs.result.options" class="mb-3" size="sm" name="Resultado"/>
                <span class="error">{{ errors.first('Resultado') }}</span>
              </b-form-group>
            </b-col>

          </b-row>

          <b-row>
            <b-col :cols='4'>
              <b-form-group id="exampleInputGroup1"
                            label="Observaciones:"
                            label-for="exampleInput1"
                            description="">
                <b-form-textarea :rows='4' v-model="inputs.comments" class="mb-3" size="sm" name="Observaciones"
                                 v-validate="ObsValidate"/>
                <span class="error">{{ errors.first('Observaciones') }}</span>
              </b-form-group>
            </b-col>

            <b-col :cols='4'>
              <b-form-group id="exampleInputGroup1"
                            label="Invitados:"
                            label-for="exampleInput1"
                            description="">
                <b-form-textarea :rows='2' v-model="inputs.guests" class="mb-3" size="sm" name="Invitados"/>
              </b-form-group>
            </b-col>

            <b-col :cols='4'>
              <b-form-group id="exampleInputGroup1" class="mt-32">
                <a target="_top" :href="sendEmailGuests">
                  <b-button size='sm' variant='default'>
                    <i class='p-0 fa fa-envelope'></i>&nbsp; Enviar correo a invitados
                  </b-button>
                </a>
              </b-form-group>
            </b-col>

            <!-- <b-col :cols='6'>
               <b-form-group id="exampleInputGroup1"
                               label="Visitado por gestor:"
                               label-for="exampleInput1"
                               description="">
                   <switches
                       v-model="inputs.visitedByManager"
                       style="margin-top: .5rem;"
                       color="blue">
                   </switches>
               </b-form-group>
           </b-col> -->

          </b-row>
          <b-row>
            <b-col style="text-align: right;">
              <b-button @click='goBackDetails' variant="secondary">Cancelar</b-button>
              <b-button @click='saveNewVisit' variant="primary">Guardar</b-button>
            </b-col>
          </b-row>
        </b-form>
      </b-col>
    </b-row>
    <div v-else>
      <h3>Nueva Entidad</h3>
      <b-row>
        <b-col>
          <b-form>
            <b-form-group style="font-size: 1rem;" label="Código">
              <b-form-input v-model="newEntity.codigo_entidad"></b-form-input>
            </b-form-group>
          </b-form>
        </b-col>
        <b-col>
          <b-form>
            <b-form-group style="font-size: 1rem;" label="Nombre">
              <b-form-input v-validate="'required'" name="Nombre" v-model="newEntity.nombre_entidad"></b-form-input>
              <span class="error">{{ errors.first('Nombre') }}</span>
            </b-form-group>
          </b-form>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-form>
            <b-form-group style="font-size: 1rem;" label="Tipo">
              <b-form-select v-validate="'required'" name="Tipo"
                             text-field="descripcion" value-field="id"
                             v-model="newEntity.id_tipo_entidad"
                             :options="tipo_entidad_options"
                             class="mb-3"
                             :disabled="tipo_entidad_options.length===0"/>
              <span class="error">{{ errors.first('Tipo') }}</span>
            </b-form-group>
          </b-form>
        </b-col>
        <b-col>
          <b-form>
            <b-form-group style="font-size: 1rem;" label="Dato contacto">
              <b-form-input v-model="newEntity.datos_contacto"></b-form-input>
            </b-form-group>
          </b-form>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-form>
            <b-form-group style="font-size: 1rem;" label="Dirección">
              <b-form-input v-validate="'required'" name="Dirección" v-model="newEntity.direccion"></b-form-input>
              <span class="error">{{ errors.first('Dirección') }}</span>
            </b-form-group>
          </b-form>
        </b-col>
        <b-col>
          <b-form>
            <b-form-group style="font-size: 1rem;" label="CIF">
              <b-form-input v-validate="'required'" name="CIF" v-model="newEntity.cif"></b-form-input>
              <span class="error">{{ errors.first('CIF') }}</span>
            </b-form-group>
          </b-form>
        </b-col>
      </b-row>
      <!-- <b-row>
        <b-col>
          <b-form>
            <b-form-group style="font-size: 1rem;" label="URL gestión entidad">
                <b-form-input v-model="newEntity.codigo"></b-form-input>
            </b-form-group>
          </b-form>
        </b-col>
      </b-row> -->
      <b-row>
        <b-col style="text-align: right;">
          <b-button @click='EntityForm = false' variant="secondary">Cancelar</b-button>
          <b-button @click='saveEntity' variant="primary">Guardar</b-button>
        </b-col>
      </b-row>
    </div>
    <div v-if="showAlert" class="div-full">
      <b-alert class="alert-class" show dismissible variant="primary" @dismissed="showAlert=false">
        {{ alertText }}
      </b-alert>
    </div>
  </div>
</template>

<style scoped>
.div-full {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  background-color: #0000006b;
}

.alert-class {
  position: relative;
  top: 50%;
  width: 75%;
  left: 15%;
}

.mt-24  {
  margin-top: 24px;
}

.mt-32  {
  margin-top: 32px;
}

</style>

<script>

import Datepicker from 'vuejs-datepicker';
import Switches from 'vue-switches';

import moment from 'moment';

export default {
  $_veeValidate: {
    validator: 'new'
  },
  name: 'ManageVisitsEntitiesResultsNew',
  props: [],
  components: {Datepicker, Switches},
  data () {
    return {
      showAlert: false,
      alertText: '',
      EntityForm: false,
      newEntity: {
        codigo_entidad: null,
        nombre_entidad: null,
        id_tipo_entidad: null,
        datos_contacto: null,
        direccion: null,
        cif: null
      },
      tipo_entidad_options: [],
      alertSaved: 0,
      inputs: {
        distributor: {
          options: [],
          value: null
        },
        entity: {
          value: null,
          options: []
        },
        visitador: '',
        status: {
          options: [],
          value: null
        },
        scheduledDate: null,
        visitedDate: null,
        activityType: {
          options: [],
          value: null
        },
        result: {
          options: [],
          value: null
        },
        comments: null,
        guests: null,
        visitedByManager: false
      }
    };
  },
  computed: {
    currentDate: function () {
      return moment().format();
    },
    disabledOffer: function () {
      if (this.inputs.entity.value) {
        if (this.inputs.entity.value.codigoEntidad) {
          return false;
        }
      }
      return true;
    },
    ObsValidate: function () {
      // return 'required|max:1000'
      if (this.inputs.status.value === 3) {
        return 'required|max:1000';
      } else {
        return 'max:1000';
      }
    },
    isPRO: function () {
      return (window.location.hostname === 'geovisor.kernel-analytics.com' || window.location.hostname === 'geovisor.nedgia.es');
    },
    sendEmailGuests: function () {
      if (this.inputs.guests) {
        var subject = '[Asunto provisional] Por determinar';

        return 'mailto:' + this.inputs.guests.replace(';', ',') + '?subject=' + subject;
      }
    },
    isPlanifiedRequired: function () {
      if (this.inputs.status.value === 1) {
        return 'required:true';
      }
      return '';
    },
    isDoneRequired: function () {
      if (this.inputs.status.value === 3) {
        return 'required:true';
      }
      return '';
    }
  },
  created: function () {
    this.processData();
    this.populateEntities();
  },
  mounted: function () {
    this.$http.get('tipo_entidad/', {params: {not_paginated: true}}).then(result => {
      this.tipo_entidad_options = result.data;
    });
  },
  methods: {
    sendEmail: function () {
      // TODO
      var mail = document.createElement('a');
      mail.id = 'sendMail';
      mail.target = '_top';
      var body = `Complete los siguientes campos de la nueva empresa que desea registrar:


      Nombre*:
      Dirección*:
      NIF*:
      Tipo Entidad*: (indicar uno de los tipos)
        [] EMPRESA COLABORADORA
        [] CUENTAS NACIONALES
        [] ADMINISTRADORES FINCAS
      Código SAP:
      Datos de Contacto:


      *Dato necesario
      `;

      // mail.href = 'mailto:someone@example.com?subject=Hello&body=test'
      const supportEmail = process.env.SUPPORT_EMAIL;
      mail.href = `mailto:${supportEmail}?subject=Solicitud%20alta%20nueva%20Entidad%20GeoVisor&body=` + encodeURI(body);

      var p = document.getElementById('inputGroup');
      p.appendChild(mail);

      document.getElementById('sendMail').click();

      p.removeChild(mail);
    },
    showEntityForm: function () {
      this.newEntity = {
        codigo_entidad: null,
        nombre_entidad: null,
        id_tipo_entidad: null,
        datos_contacto: null,
        direccion: null,
        cif: null
      };
      this.EntityForm = true;
    },
    saveEntity: function () {
      this.$validator.validate().then(result => {
        if (!result) {
          alert('Tienes algún error en el formulario');
        } else {
          this.$http.post('entities/', this.newEntity).then(result => {
            var option = {
              value: result.data['id'],
              codigoEntidad: result.data['codigo_entidad'],
              name: result.data['nombre_entidad'] + ' (CIF: ' + result.data['cif'] + ') - (SAP:' + result.data['codigo_entidad'] + ')'
            };
            this.inputs.entity.options.push(option);
            this.inputs.entity.value = option;
            this.EntityForm = false;
          });
        }
      });
    },
    showPublicOffer: function () {
      if (this.inputs.entity.value) {
        this.$http.get('entidades_op/', {params: {codigo_entidad: this.inputs.entity.value.codigoEntidad}}).then(response => {
          // alert(response.body.map((obj) => { return obj.distribuidora }))
          var list = response.body.map((obj) => {
            return obj.distribuidora;
          });
          if (!list.length) {
            list = ['Empresa no adherida a la Oferta Pública'];
          }
          this.alertText = list.join(', ');
          this.showAlert = true;
        });
      }
    },

    populateEntities: function () {
      this.$http.get('entities/').then(response => {
        let options = [];

        var data = response.body;

        for (let i = 0; i < data.length; ++i) {
          options.push({
            value: data[i]['id'],
            codigoEntidad: data[i]['codigo_entidad'],
            name: data[i]['nombre_entidad'] + ' (CIF: ' + data[i]['cif'] + ') - (SAP:' + data[i]['codigo_entidad'] + ')'
          });
        }

        this.inputs.entity.options = options;
      });
    },

    populateDistributors: function () {
      this.$http.get('distribuidoras/').then(response => {
        let options = [];
        for (const distribuidora of response.data) {
          options.push({
            value: distribuidora.nombre,
            text: distribuidora.nombre
          });
        }

        if (options.length < 1) {
          options.push({value: null, text: 'Desconocida'});
        } else {
          this.inputs.distributor.value = options[0].value;
        }

        this.inputs.distributor.options = options;
      });
    },

    saveNewVisit () {
      this.$validator.validate().then(result => {
        if (!result) {
          alert('Tienes algún error en el formulario');
        } else {
          this.alertSaved = false;

          let modifications = {};

          // modifications['id_visita_entidad'] =
          modifications['id_entidad'] = this.inputs.entity.value.value;
          modifications['codigo_visitador'] = this.$parent.$parent.currentManager.id;
          modifications['tipo_actividad_visita_entidad'] = this.inputs.activityType.options.filter(e => e.value === this.inputs.activityType.value)[0].text;
          modifications['status_visita'] = this.inputs.status.options.filter(e => e.value === this.inputs.status.value)[0].text;
          modifications['id_resultado_visita'] = this.inputs.result.value;
          modifications['observaciones'] = this.inputs.comments;
          modifications['invitados'] = this.inputs.guests;
          modifications['create_user'] = this.$parent.$parent.currentManager.id;
          modifications['create_date'] = moment().format('YYYY-MM-DD HH:mm:ss');
          modifications['update_user'] = null;
          modifications['update_date'] = null;
          modifications['nombre_visitador'] = this.$parent.$parent.currentManager.name;
          modifications['distribuidora'] = this.inputs.distributor.value;

          if (this.inputs.visitedDate !== null && this.inputs.visitedDate !== '') {
            modifications['fecha_hora_visita'] = this.inputs.visitedDate.split('+')[0] + '+00:00';
          }

          if (this.inputs.scheduledDate !== null && this.inputs.scheduledDate !== '') {
            modifications['fecha_hora_proxima_visita'] = this.inputs.scheduledDate.split('+')[0] + '+00:00';
          }

          //   modifications['tipo_actividad_visita_entidad'] = this.inputs.activityType.options.filter(e => e.value === this.inputs.activityType.value)[0].text
          //   modifications['id_resultado_visita'] = this.inputs.result.value
          //   modifications['observaciones'] = this.inputs.comments
          //   modifications['invitados'] = this.inputs.guests

          //   // modifications[]

          this.$http.post('visitas_entidades/', modifications).then(result => {
            this.alertSaved = 1;

            this.$validator.clean();

            this.inputs.entity.value = null;
            this.inputs.activityType.value = null;
            this.inputs.status.value = null;
            this.inputs.comments = null;
            this.inputs.guests = null;
            this.inputs.distributor.value = null;
            this.inputs.result.value = null;
            this.inputs.scheduledDate = null;
            this.inputs.visitedDate = null;
          }, error => {
            console.log(error);
            this.alertSaved = 2;
            // console.log(error)
            // this.$http.post('correccion_comercial/', this.modification).then(result => {
            //     alert('Guardado con éxito!')
            //     this.loading = false
            // })
          });
        }
      });
    },

    goBackDetails () {
      this.$emit('closed');
    },

    processData () {
      Promise.all([
        this.$http.get('status_visitas/', {params: {not_paginated: true}}),
        this.$http.get('tipo_actividad_visitas_entidades/', {params: {not_paginated: true}}),
        this.$http.get('resultados_visitas/', {params: {not_paginated: true}})
      ]).then(results => {
        this.inputs.status.options = results[0].data.map((obj) => {
          return {text: obj.visita_status, value: obj.id};
        });
        this.inputs.activityType.options = results[1].data.map((obj) => {
          return {text: obj.descripcion, value: obj.id};
        });
        this.inputs.result.options = results[2].data.map((obj) => {
          return {text: obj.resultado, value: obj.id};
        });

        this.inputs.visitador = this.$parent.$parent.currentManager.name + '( ' + this.$parent.$parent.currentManager.id + ')';

        this.populateDistributors();

        // this.$http.get('visitas_entidades/' + this.idVisita + '/').then(responseVisita => {
        //   const data = responseVisita.body

        //   // OK

        //   if (data.fecha_hora_visita) { this.inputs.visitedDate = data.fecha_hora_visita }

        //   if (data.fecha_hora_proxima_visita !== null) { this.inputs.scheduledDate = data.fecha_hora_proxima_visita } // .split('+')[0] + '+00:00' }

        //   this.inputs.activityType.value = this.inputs.activityType.options.filter(e => e.text === data.tipo_actividad_visita_entidad)[0].value

        //   this.inputs.result.value = data.id_resultado_visita_dict.id

        //   this.inputs.status.value = this.inputs.status.options.filter(e => e.text === data.status_visita)[0].value

        //   this.inputs.comments = data.observaciones
        //   this.inputs.guests = data.invitados
        //   // this.inputs.visitedByManager = data.visitado_gestor
        // })
      });
    }

  }
};
</script>



// WEBPACK FOOTER //
// src/components/Layout/CommercialManagement/ManageVisitsEntitiesResultsNew.vue